<div class="w-full block">
  <img src="/assets/images/banner.png" alt="banner" class="w-1/2 mx-auto" />
</div>

<div class="bg-white p-4 border-b border-gray-300 z-50">
  <!-- <h1 class="m-0 text-lg font-bold">Dream Talents Terms of Service</h1> -->
</div>

<main class="flex items-start p-5">
  <section class="flex-1 pr-5">
    <h2 class="text-black text-[40px] font-bold mb-4">Dream Talents Terms of Service</h2>

    <!-- SECTION 1 -->
    <h3 id="section1" class="text-black font-bold text-[32px] mb-2">1. General Terms</h3>
    <p class="mb-2 text-lg">1.1. By using this application, you agree to abide by these policies and all applicable laws and regulations.</p>
    <p class="mb-2 text-lg">1.2. You are responsible for maintaining the confidentiality of your login credentials and any associated accounts.</p>
    <p class="mb-4 text-lg">1.3. This application is intended for lawful purposes only. Misuse of the application for fraudulent, malicious, or illegal activities is strictly prohibited.</p>

    <!-- SECTION 2 -->
    <h3 id="section2" class="text-black font-bold text-[32px] mb-2">2. Compliance with Facebook Policies</h3>
    <p class="mb-2 text-lg">2.1. All campaigns, ad sets, and ads created, managed, or modified using this application must comply with Facebook's Advertising Policies.</p>
    <p class="mb-2 text-lg">2.2. Content uploaded, such as images, videos, or text, must not violate Facebook's Community Standards or any other applicable platform policies.</p>
    <p class="mb-4 text-lg">2.3. Users are responsible for ensuring that their ads comply with regional laws and industry regulations, such as GDPR, CCPA, or other privacy laws.</p>

    <!-- SECTION 3 -->
    <h3 id="section3" class="text-black font-bold text-[32px] mb-2">3. User Responsibilities</h3>
    <p class="mb-2 text-lg">3.1. Users must provide accurate and truthful information in their campaigns, including ad copy, target audience data, and billing details.</p>
    <p class="mb-2 text-lg">3.2. Users must not engage in deceptive practices, including clickbait, misrepresentation, or unauthorized data collection.</p>
    <p class="mb-4 text-lg">3.3. Users must ensure that all uploaded creatives (images, videos, etc.) are original or have the necessary rights and permissions for use.</p>

    <!-- SECTION 4 -->
    <h3 id="section4" class="text-black font-bold text-[32px] mb-2">4. Restricted Activities</h3>
    <p class="mb-2 text-lg">4.1. Scraping or harvesting data from Facebook or this application is prohibited.</p>
    <p class="mb-2 text-lg">4.2. Using the application to promote prohibited products, such as illicit drugs, counterfeit goods, or misleading financial services, is not allowed.</p>
    <p class="mb-4 text-lg">4.3. Misuse of targeting options to discriminate against individuals based on protected categories (e.g., race, gender, religion) is strictly forbidden.</p>

    <!-- SECTION 5 -->
    <h3 id="section5" class="text-black font-bold text-[32px] mb-2">5. Data Privacy and Security</h3>
    <p class="mb-2 text-lg">5.1. Users must respect the privacy of individuals and must not use personal data for unauthorized purposes.</p>
    <p class="mb-2 text-lg">5.2. The application does not store user passwords or sensitive information in plaintext and ensures compliance with data security standards.</p>
    <p class="mb-4 text-lg">5.3. Users must not use the application to collect sensitive personal information, such as credit card details, without proper authorization and safeguards.</p>

    <!-- SECTION 6 -->
    <h3 id="section6" class="text-black font-bold text-[32px] mb-2">6. Termination of Access</h3>
    <p class="mb-2 text-lg">6.1. Any violation of these policies may result in suspension or termination of access to the application.</p>
    <p class="mb-4 text-lg">6.2. The application reserves the right to deactivate accounts found engaging in harmful activities or non-compliance with Facebook policies.</p>

    <!-- SECTION 7 -->
    <h3 id="section7" class="text-black font-bold text-[32px] mb-2">7. Limitation of Liability</h3>
    <p class="mb-2 text-lg">7.1. The application is not responsible for the suspension or rejection of ads by Facebook. Users are encouraged to thoroughly review their ad submissions.</p>
    <p class="mb-4 text-lg">7.2. The application is not liable for losses incurred due to user error, account suspension, or third-party actions.</p>

    <!-- SECTION 8 -->
    <h3 id="section8" class="text-black font-bold text-[32px] mb-2">8. Updates to the Policy</h3>
    <p class="mb-2 text-lg">8.1. The application reserves the right to modify this policy at any time.</p>
    <p class="mb-4 text-lg">8.2. Users will be notified of significant changes through in-app notifications or email.</p>
  </section>

  <!-- TOC -->
	<nav class="sticky top-5 max-h-[80vh] overflow-y-auto p-4 bg-[#f8f9fa] border-l-2 border-gray-300 min-w-[250px]">
		<h2 class="text-black text-[32px] pb-4">Table of contents</h2>
		<ul class="list-none text-lg flex flex-col gap-2">
			<li *ngFor="let item of tocItems">
				<a (click)="scrollTo(item.id)" 
					class="no-underline text-black cursor-pointer hover:underline">
					{{ item.title }}
				</a>
			</li>
		</ul>
	</nav>
</main>
